export default __webpack_public_path__ + "static/media/mint_cross.68106268.svg";